var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 301,
    viewBox: "0 0 300 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.051 295.653C149.434 302.801 164.677 302.782 177.022 295.597L203.311 280.318L109.76 226.311C81.4853 209.992 64.071 179.824 64.071 147.167V39.0986L37.6711 54.2479C25.2881 61.3585 17.6392 74.5584 17.6392 88.8351V173.66C17.6392 206.484 35.1463 236.819 63.5698 253.231L137.033 295.634L137.051 295.653Z",
    fill: "url(#paint0_linear_1224_13155)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.49 10.6198C156.675 17.359 145.759 31.153 143.011 47.7319C142.584 50.3682 142.342 53.0601 142.342 55.8078V127.916C142.342 136.214 144.589 144.197 148.599 151.141C152.591 158.084 158.401 163.988 165.586 168.128L187.865 180.957C199.078 187.417 212.092 191.112 225.961 191.112C247.942 191.112 267.77 181.848 281.731 167.014V208.489C281.731 216.751 279.522 224.678 275.549 231.584C271.539 238.546 265.746 244.469 258.543 248.627C244.21 256.907 226.536 256.907 212.204 248.627L164.658 221.188L130.071 201.211C108.962 189.033 95.9663 166.494 95.9663 142.137V47.3234C95.9663 39.0433 98.1756 31.0602 102.167 24.1354C106.159 17.1919 111.951 11.3067 119.117 7.16665C133.487 -1.11349 151.142 -1.11349 165.475 7.16665L171.49 10.6384V10.6198Z",
    fill: "url(#paint1_linear_1224_13155)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M247.608 54.5827C268.717 66.7616 281.731 89.2813 281.731 113.658V113.732C281.731 143.826 258.172 169.112 228.096 170.245C222.378 170.449 216.845 169.799 211.61 168.407C225.422 160.646 235.318 145.998 235.318 127.897C235.318 115.663 230.528 104.134 222.248 95.5749C219.296 92.5116 215.898 89.8382 212.092 87.6475L163.154 59.3911V55.938C163.154 39.9347 176.113 26.9946 192.098 26.9946C197.017 26.9946 201.659 28.2199 205.706 30.3921L247.608 54.5827Z",
    fill: "url(#paint2_linear_1224_13155)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1224_13155",
    x1: 12.1624,
    y1: 68.9888,
    x2: 151.495,
    y2: 310.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#F6B360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36C64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1224_13155",
    x1: 103.615,
    y1: 16.1151,
    x2: 243.022,
    y2: 257.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#F6B360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36C64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1224_13155",
    x1: 185.655,
    y1: 26.2334,
    x2: 261.792,
    y2: 158.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F14A66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#F03367"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNew);
export default __webpack_public_path__ + "static/media/logo-new.14346e8d1ab256bb5d5843cabe9c40b3.svg";
export { ForwardRef as ReactComponent };